import api, { api_v2 } from "./api"
import type { Company, CompanyParamsType } from "../types/company"

export interface CompaniesResponse {
  data: Company[]
}

export const getCompanies = async (
  params?: CompanyParamsType | null
): Promise<CompaniesResponse> => {
  try {
    const response = await api.get<CompaniesResponse>("/mentorias/listar-empresas", {
      params: params,
    })

    return response.data
  } catch (error) {
    console.error("Error fetching companies:", error)

    throw error
  }
}

export const getCompaniesV2 = async (
  params?: CompanyParamsType | null
): Promise<CompaniesResponse> => {
  try {
    const response = await api_v2.get("/mentoria/empresas", {
      params: params,
    })

    return response.data
  } catch (error) {
    console.error("Error fetching companies:", error)

    throw error
  }
}

export const getCompanyById = async (
  emp_id: string,
  params?: CompanyParamsType | null
): Promise<Company> => {
  try {
    const response = await api.get<Company>(`/empresas/${emp_id}`, {
      params: params,
    })

    return response.data
  } catch (error) {
    console.error("Error fetching companies:", error)

    throw error
  }
}
